import {createI18n} from 'vue-i18n'

import en from './locales/en.json'
import de from './locales/de.json'
import it from './locales/it.json'

export type Locale = 'en' | 'de' | 'it'

const navigatorLanguage = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language

export const FALLBACK_LOCALE = 'en'

export const browserLanguage = navigatorLanguage.split('-')[0] || FALLBACK_LOCALE
export const browserLocale = navigatorLanguage

const i18n = createI18n({
  legacy: false,
  locale: browserLanguage,
  fallbackLocale: FALLBACK_LOCALE,
  globalInjection: true,
  messages: {
    en: en,
    de: de,
    it: it,
  },
})

export default i18n
